import React from "react";
import { useLocation } from "react-router-dom";
// from react-router-v5 docs

function useQuery(): URLSearchParams {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default useQuery;
